import React from 'react';
import { inject, observer } from 'mobx-react';

import { trans } from '../../../../common/utils';
import Markets from '../common/markets';

const FavMarketsList = ({ matchInstance, activeMarketGroup, store }) => {
    return (
        <div className="my-favorite-markets">
            <div className="my-favorite-markets__header">{trans('My Favorite Markets')}</div>
            {store.betting.bettingErrors.favoriteMarkets ? (
                <div className="my-favorite-markets__no-content">
                    <span className="my-favorite-markets__no-content-text">
                        {trans(store.betting.bettingErrors.favoriteMarkets)}
                    </span>
                </div>
            ) : matchInstance?.favoriteMarketsLength ? (
                <div>
                    {matchInstance?.favoriteMarketsByGroups.map((marketGroup) => {
                        return (
                            <div className="match-details__market-group" key={marketGroup.id}>
                                <Markets
                                    match={matchInstance}
                                    marketGroup={marketGroup}
                                    userCanCashout={store.user.canCashout}
                                    viewSize={store.site.status.viewSize}
                                    isOldView={store.user.isOldMarketsView}
                                    setOldView={store.user.setMarketViewType}
                                    activeMarketGroup={activeMarketGroup}
                                    isFavorite={true}
                                    user={store.user}
                                    site={store.site}
                                    favorites={store.betting.favorites}
                                    modal={store.modal}
                                />
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div className="my-favorite-markets__no-content">
                    <i className="my-favorite-markets__no-content-icon doruk-star-line"></i>
                    <span className="my-favorite-markets__no-content-text">{trans('MY_FAV_MARKET_LIST_EMPTY')}</span>
                </div>
            )}
        </div>
    );
};

export default inject('store')(observer(FavMarketsList));
